import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { customerQuotationList } from "constants/customerQuotation";

//get the customer quotation list
export const getCustomerQuotationList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_customer_quotation_list(pageNum, filters);
    dispatch({ type: customerQuotationList, payload: res.data });
  } catch (error) {
    dispatch({ type: customerQuotationList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};
